import {useState} from 'react'
 
import FarmerSeasonForm from './FarmerSeasonForm';
import FarmerSeasonList from './FarmerSeasonList';

const FarmerSeason = () => {
  const [formIsShown, setFormIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {formIsShown ? (
        <FarmerSeasonForm addForm={setFormIsShown} update={upData} sId={serviceId}/>
      ) : (
        <FarmerSeasonList addForm={setFormIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default FarmerSeason